<template>
  <modal ref="filterModal" v-model="show" title="Add filter" :backdrop="false"
         :before-close="beforeClose">
    <form v-on:submit.prevent="onConfirm">
      <transition name="fade" mode="out-in">
        <component v-if="currentForm.type==='filterSelect'" v-bind:is="'filterSelect'" :values="currentForm.values"
                   :options="filterOptions" :errors="currentForm.errors"/>
        <component v-else v-bind:is="currentForm.type + '-filter'" :values="currentForm.values"
                   :errors="currentForm.errors"/>
      </transition>
    </form>
    <div slot="footer">
      <transition name="fade">
        <btn v-if="currentForm.type!=='filterSelect' && !currentForm.editing" class="pull-left" type="danger"
             v-on:click="onBack">
          Back
        </btn>
      </transition>
      <btn v-if="!currentForm.editing" v-on:click="onCancel">
        Cancel
      </btn>
      <btn class="float-right" type="primary" v-on:click="onConfirm">
        OK
      </btn>
    </div>
  </modal>
</template>
<script>
  import * as R from 'ramda'
  import Vue from 'vue'
  import EventsAPI from '@/app/api/phq-public/events'
  import { FILTER_OPTIONS, ADDON_ACCESS, AVIATION_RANK_FILTERS, PHQ_ATTENDANCE_FILTER } from '@/app/wdc/form/fixtures'
  import rankFilter from '@/components/wdc/filters/rank'
  import rankRangeFilter from '@/components/wdc/filters/rank-range'
  import localRankFilter from '@/components/wdc/filters/local-rank'
  import localRankRangeFilter from '@/components/wdc/filters/local-rank-range'
  import aviationRankFilter from '@/components/wdc/filters/aviation-rank'
  import aviationRankRangeFilter from '@/components/wdc/filters/aviation-rank-range'
  import categoryFilter from '@/components/wdc/filters/category'
  import filterSelect from '@/components/wdc/filters/filter'
  import labelFilter from '@/components/wdc/filters/label'
  import countryFilter from '@/components/wdc/filters/country'
  import stateFilter from '@/components/wdc/filters/state'
  import placeFilter from '@/components/wdc/filters/place'
  import withinFilter from '@/components/wdc/filters/within'
  import queryFilter from '@/components/wdc/filters/query'
  import activeFilter from '@/components/wdc/filters/active'
  import updatedFilter from '@/components/wdc/filters/updated'
  import startFilter from '@/components/wdc/filters/start'
  import endFilter from '@/components/wdc/filters/end'
  import PhqAttendanceFilter from '@/components/wdc/filters/phq-attendance'

  export default {
    components: {
      filterSelect,
      labelFilter,
      rankFilter,
      rankRangeFilter,
      localRankFilter,
      localRankRangeFilter,
      aviationRankFilter,
      aviationRankRangeFilter,
      categoryFilter,
      countryFilter,
      stateFilter,
      withinFilter,
      queryFilter,
      activeFilter,
      updatedFilter,
      placeFilter,
      startFilter,
      endFilter,
      PhqAttendanceFilter
    },
    props: ['currentForm', 'onConfirm', 'onCancel', 'onBack', 'beforeClose', 'filterOptions', 'show'],
    name: 'filterTable',
    data () {
      return {
        options: FILTER_OPTIONS
      }
    },
    beforeCreate () {
      // It would be better to use Vuex state
      if (FILTER_OPTIONS.labels.length === 0) {
        EventsAPI.count({}, Vue.config.token).then(response => {
          FILTER_OPTIONS.labels = Object.entries(response.labels).map(eventLabel => eventLabel[0]).sort()
          ADDON_ACCESS.aviation_rank = R.has('aviation_rank_levels', response)
          if (ADDON_ACCESS.aviation_rank) {
            FILTER_OPTIONS.filterTypes = R.sortBy(R.prop('value'))(R.concat(FILTER_OPTIONS.filterTypes, AVIATION_RANK_FILTERS))
          }
          return response.count
        }).then(totalEventCount => {
          EventsAPI.count({'phq_attendance.gt': 0}, Vue.config.token).then(response => {
            // If the events count with the phq_attendance > 0 filter is
            // different to without, then it means the filter works for the
            // user, i.e. they have the phq_attendance feature.
            ADDON_ACCESS.phq_attendance = response.count < totalEventCount
            if (ADDON_ACCESS.phq_attendance) {
              FILTER_OPTIONS.filterTypes = R.sortBy(R.prop('value'))(R.append(PHQ_ATTENDANCE_FILTER, FILTER_OPTIONS.filterTypes))
            }
          })
        })
      }
    }
  }
</script>
<style>
</style>
